'use client';

import { GeneralContext } from '@frodo/lib/providers/GeneralProvider';
import { useContext } from 'react';

export const usePage = () => {
  const context = useContext(GeneralContext);

  if (!context) {
    throw new Error('usePage must be used within a GeneralProvider');
  }

  return context.pageType;
};
